import { Lightning } from '@lightningjs/sdk'
import { Toggle } from '@lightningjs/ui-components';
import { Helper } from '../../lib/helper';

export default class ProfileScreen extends Lightning.Component {
    _isSuccess = false
    static override _template() {
        return {
            Container: {
                x: (w) => w / 2,
                y: (h) => h / 2,
                mount: 0.5,
                w: 1000,
                h: 400,
                rect: true,
                collision: true,
                forceZIndexContext: true,
                color: 0xff000000,
                Label: {
                    x: 20, y: 20,
                    text: { text: 'Parental Control', fontFace: Helper.getFontFamily('Regular'), fontSize: 38, textColor: 0xffffffff }
                },
                Body: {
                    rect: true,
                    y:90,
                    h:215,
                    w: (w) => w,
                    collision: true,
                    color: 0xff222222,
                    flex: { justifyContent: 'center', alignItems: 'center' },
                    ToggleSwitch: {
                        h: 120,
                        w: 300,
                        zIndex:82,
                        collision:true,
                        type: Toggle,
                        style: {
                            h: 120, w: 300,
                            knobHeight: 100,
                            knobWidth: 100,
                            knobRadius: 110,
                            knobPadding: 6,
                            knobColor: 0xffffffff,
                            knobColorChecked: 0xffffffff,
                            backgroundColor: 0xfff34966,
                            backgroundColorChecked: 0xff3cb371
                        },
                        active: false,
                        label: {
                            x: 0,
                            y: 0,
                            text: { text: 'OFF', fontSize: 48,fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff }
                        }
                    }
                },
                StatusText: {
                    x: 20, y: 335,
                    text: { text: 'Parental Controls are turned off', fontSize: 30,fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff }
                }
            }
        };
    }

    override _init(): void {
        let acontent = Helper.getAcontent();
        this.tag('ToggleSwitch').checked = !acontent
        this.tag('ToggleSwitch').onEnter = this.onEnter.bind(this)
        if(this.isSuccess) {
            setTimeout(()=>{
                const toggle = this.tag('ToggleSwitch')
                this.updateAContent(!acontent)
                acontent = Helper.getAcontent();
                toggle.toggle()
                this.reloadApp(acontent)
            },250)    
        }
    }

    // override _handleBack(e: KeyboardEvent): boolean | void {
    //     this.signal('back')
    //     return false
    // }

    reloadApp(acontent) {
        setTimeout(()=>{
            this.signal('reloadApp', acontent)
        },250)
    }

    onEnter (toggle) {
        //console.log(toggle.checked)
        if(Helper.getPIN()) {
            this.signal('verifyPin')
            // this.updateAContent(toggle.checked)
            // toggle.toggle();
        } else {
            this.signal('login')
        }        
    };

    override _getFocused(): Lightning.Component | null | undefined {
        return this.tag('ToggleSwitch')
    }

    updateAContent(state:boolean) {
        Helper.setAContent(state)
    }

    _handleClick(target) {
        this.onEnter(null)
    }

}